import {useMemo} from 'react';
import type {Schema} from 'schemaDefinition/types';
import type {CodeListId} from 'services/codelists/types';
import {getSchemaListCodelistIds} from 'schemaDefinition/functions';
import type {LinkedRoleCodeListId} from 'schemaDefinition/types/linkTypes';

export const useSchemaListCodelistIds = (
  schemas: Schema[],
): (CodeListId | LinkedRoleCodeListId)[] => {
  return useMemo(() => getSchemaListCodelistIds(schemas), [schemas]);
};
